// extracted by mini-css-extract-plugin
module.exports = {"container":"_253b699","brand":"_18156e7"};